import { Controller } from "stimulus";
import centreInScroller from "./centre_in_scroller";

// Centres the picked podcast, shows the fade and arrow only on an edge with more pills past it, and pages the row with the arrows.
export default class PodcastChipsController extends Controller {
  static targets = ["row", "previous", "next"];

  connect() {
    this.layout();
    this.resizeObserver = new ResizeObserver(() => this.sync());
    this.resizeObserver.observe(this.rowTarget);
    // The theme's web font can widen the pills after connect without resizing the row; re-centre only if the viewer hasn't scrolled since.
    document.fonts?.ready.then(() => {
      if (!this.element.isConnected) return;
      if (this.rowTarget.scrollLeft === this.centredAt) this.layout();
      else this.update();
    });
  }

  disconnect() {
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  layout() {
    const active = this.rowTarget.querySelector('[aria-current="true"]');
    if (active) centreInScroller(this.rowTarget, active);
    this.centredAt = this.rowTarget.scrollLeft;
    this.update();
  }

  // Scroll and resize land here; one update per frame.
  sync() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.update());
  }

  update() {
    const row = this.rowTarget;
    const hiddenLeft = row.scrollLeft > 1;
    const hiddenRight = row.scrollLeft < row.scrollWidth - row.clientWidth - 1;
    if (hiddenLeft === this.hiddenLeft && hiddenRight === this.hiddenRight) return;

    this.hiddenLeft = hiddenLeft;
    this.hiddenRight = hiddenRight;
    this.element.style.setProperty("--fade-left", hiddenLeft ? "48px" : "0px");
    this.element.style.setProperty("--fade-right", hiddenRight ? "48px" : "0px");
    this.previousTarget.hidden = !hiddenLeft;
    this.nextTarget.hidden = !hiddenRight;
  }

  previous() {
    this.rowTarget.scrollBy({ left: -this.rowTarget.clientWidth * 0.8 });
  }

  next() {
    this.rowTarget.scrollBy({ left: this.rowTarget.clientWidth * 0.8 });
  }
}
